import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

/**
 * Komponent do aktualizacji klucza API merchanta
 */
class P24MerchantAuthApiKey extends React.Component {

    state = {
        merchantAuth: { ...this.props.merchantAuth, p24ApiKey: '' }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit(this.state.merchantAuth);
    };

    /**
     * Obsługa zmiany pól tekstowych
     */
    handleInputChange = e => {

        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        let merchantAuth = { ...this.state.merchantAuth, [name]: value };
        this.setState({ merchantAuth });

    };

    render() {

        return (

            <div className="w3-card-4">
                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">{this.props.title}</h5>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s8">
                        <input
                            className="w3-input"
                            type="text"
                            name="p24ApiKey"
                            onChange={this.handleInputChange}
                            value={this.state.merchantAuth.p24ApiKey}
                            maxLength="50"
                        ></input>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Merchant.p24ApiKey"
                                defaultMessage="p24ApiKey"
                            />
                        </label>
                    </div>

                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>
                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.submitText}
                        </button>
                    </div>
                </form>

            </div>

        )
    }
}

//ustawienie domyslnych pol
P24MerchantAuthApiKey.defaultProps = {
    title: 'Aktualizacja klucza API',
    submitText: 'Aktualizuj'
}

P24MerchantAuthApiKey.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //dane wejsciowe obiektu do wypelnienia
    merchantAuth: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji zapisz
    submitText: PropTypes.string.isRequired
}

export default P24MerchantAuthApiKey;